import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BaseService } from 'src/app/core/services/base.service';
import { PosStoreService } from '../../pos.store.service';
import { NotificationService } from '@optsolservices/ngx-notification';
import { HelperService } from 'src/app/core/services/helper.service';
import { Request } from '@optsolservices/ngx-data-table-with-search-criteria';

@Component({
  selector: 'app-sct-search-stock-code-dialog',
  templateUrl: './sct-search-stock-code-dialog.component.html',
  styleUrls: ['./sct-search-stock-code-dialog.component.scss']
})
export class SctSearchStockCodeDialogComponent implements OnInit {
  form: FormGroup;
  stockCodesTableConfigRequest: Request = null;
  stockCodesTableDataRequest: Request = null;
  stockCodesSearchCriteriaRequest: Request = null;
  selectedKeys: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<SctSearchStockCodeDialogComponent>,
    public fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private baseService: BaseService,
    private posStoreService: PosStoreService,
    private dialog: MatDialog,
    private notificationService: NotificationService,
    private helperService: HelperService,
  ) { }

  ngOnInit() {
    this.stockCodesTableConfigRequest = {
      url: this.helperService.apiUrl('portal_sct_header_outgoing_search_stock_codes_table_config'),
      resultField: 'data',
      body: {}
    };

    console.log('this.data: ', this.data);

    this.stockCodesSearchCriteriaRequest = {
      url: this.helperService.apiUrl('portal_sct_header_outgoing_search_stock_codes_search_criteria'),
      resultField: 'data',
      body: {}
    };

    this.stockCodesTableDataRequest = {
      url: this.helperService.apiUrl('portal_sct_header_outgoing_search_stock_codes_table_content'),
      resultField: 'data',
      body: this.data?.additionalData || {}
    };
  }

  actionButtonClicked(event: any): void {
    console.log('event: ', event);
    console.log('stockCode: ', event?.data?.stockCode);
    this.baseService.executeCommand<any>('portal_sct_line_add', { sctHeaderId: this.data?.additionalData?.sctHeaderId, scannedValue: event?.data?.stockCode })
      .subscribe(response => {
        if (response.responseCode === 0) {
          // this.dialogRef.close(true);
        }
      });
  }

  close() {
    this.dialogRef.close(true);
  }


}
